import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// REDUX
import { getCanvasReadyState, getUIMaxCoverage, updateDeviceDimensions } from '@Managers/Redux/AppState/AppState';

//TYPES
import { useAppSelector } from '@Managers/Redux/Hooks';
import { reMobileDevice, reMobileDevice2, screenBreakpoints, TSceenBreakpoints, TWindowOrientation } from './UseWindowDimensions.types';

export const UseWindowDimensions = (): void => {
    const dispatch = useDispatch();
    const uiMaxCoverage = useAppSelector(getUIMaxCoverage);
    let reziseTimeMargin: any;
    const uiMaxCoverageSpace: number = 0;

    function iOS() {
        return (
            ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
            (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
        );
    }

    useEffect(() => {
        const callculateItemPosition = () => {
            clearTimeout(reziseTimeMargin);

            // reziseTimeMargin = setTimeout(() => {
            const gameContainer = document.querySelector('#app--game-container');
            gameContainer?.removeAttribute('style');

            const doc = document.body.getBoundingClientRect();
            const gameApp = document.querySelector('#app--game-container canvas');
            const bounds = gameApp?.getBoundingClientRect();
            const width: number = window.innerWidth;
            const height: number = window.innerHeight;
            //const orientation = width < height ? TWindowOrientation.portrait : TWindowOrientation.horizontal;

            let mobileCheck = false;
            let screenSize = TSceenBreakpoints.xs;
            let fullScreen = false;

            const ratioProportions = Math.round((width / height) * 10) / 10;
            const orientation = ratioProportions <= 1 ? TWindowOrientation.portrait : TWindowOrientation.horizontal;

            if (reMobileDevice.test(navigator.userAgent) || reMobileDevice2.test(navigator.userAgent.substr(0, 4))) mobileCheck = true;

            for (var key in screenBreakpoints) {
                if (width >= screenBreakpoints[key]) screenSize = key as any;
            }

            if (window.innerWidth == screen.width && window.innerHeight == screen.height) {
                fullScreen = true;
            }

            if (bounds) {
                dispatch(
                    updateDeviceDimensions({
                        docHeight: doc.height,
                        docWidth: doc.width,
                        appHeight: bounds.height,
                        appWidth: bounds.width,
                        appTopOffset: bounds.top,
                        appRightOffset: bounds.right - bounds.width,
                        appLeftOffset: bounds.left,
                        appBottomOffset: bounds.bottom - bounds.height,
                        windowOrientation: orientation,
                        windowOrientationPortrait: orientation === TWindowOrientation.portrait,
                        windowOrientationHorizontal: orientation === TWindowOrientation.horizontal,
                        isMobile: mobileCheck,
                        screenSize: screenSize,
                        fullScreen: fullScreen,
                        isiOS: iOS(),
                        aspectRatio: ratioProportions,
                        uiMaxCoverage: uiMaxCoverage * 100,
                        isTabletHorizontal: ratioProportions > 1 && ratioProportions <= 1.6,
                        isTabletPortrait: ratioProportions >= 0.7 && ratioProportions <= 1
                    })
                );
            }
            //}, 100);
        };

        callculateItemPosition();

        window.addEventListener('resize', callculateItemPosition);
        window.addEventListener('orientationchange', callculateItemPosition);

        return () => {
            window.removeEventListener('resize', callculateItemPosition);
            window.removeEventListener('orientationchange', callculateItemPosition);
        };
    }, [dispatch, uiMaxCoverage, useAppSelector(getCanvasReadyState)]);
};
